export default "__VITE_PUBLIC_ASSET__cd5c47de__"